export default function Footer() {
  return (
    <footer className="bg-[#144E5D] text-white relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="https://storage.readdy-site.link/project_files/0b0e1b0a-4eb5-4f41-b8ab-b737676bf6d1/79523803-1329-47a1-9935-1f9c81ac66e4_Curewell-BG.png?v=7a8bfa7aadabb136ea98a9f1205a18a7"
          alt=""
          className="w-full h-full object-cover opacity-100"
        />
        {/* Top gradient fade overlay */}
        <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-[#144E5D] to-transparent" />
      </div>
      <div className="max-w-7xl mx-auto px-6 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/000f6613bbd5bf7f02c140851804a982/edb968f21dc844722d3645b2f59fd129.png"
              alt="Curewell Logo"
              className="h-10 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-base text-gray-300 leading-relaxed">
              Essential medicine that's reliable, accessible, and reasonably
              priced for everyday care.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-gray-400 mb-4 whitespace-nowrap">
              Categories
            </h4>
            <div className="space-y-3">
              <a
                href="#"
                className="block text-base text-white hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                Pain Relief
              </a>
              <a
                href="#"
                className="block text-base text-white hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                Cough &amp; Cold
              </a>
              <a
                href="#"
                className="block text-base text-white hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                Digestive Health
              </a>
              <a
                href="#"
                className="block text-base text-white hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                Urinary Health
              </a>
              <a
                href="#"
                className="block text-base text-white hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                Acid Reducer
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-gray-400 mb-4 whitespace-nowrap">
              Quick Links
            </h4>
            <div className="space-y-3">
              <a
                href="#products"
                className="block text-base text-white hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                Products
              </a>
              <a
                href="#about"
                className="block text-base text-white hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                About Us
              </a>
              <a
                href="/contact"
                className="block text-base text-white hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                Contact
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-gray-400 mb-4 whitespace-nowrap">
              Follow Us
            </h4>
            <div className="space-y-3">
              <a
                href="https://www.instagram.com/mycurewell/"
                className="block text-base text-white hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                📸 Instagram
              </a>
              <a
                href="https://www.tiktok.com/@mycurewell"
                className="block text-base text-white hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                🎵 TikTok
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-500 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-400 whitespace-nowrap">
            © 2025 Curewell. All rights reserved.
          </p>
          <a
            href="https://code4ever.dev"
            target="_blank"
            rel="noopener noreferrer"
            className="md:mr-[30px] inline-flex flex-col items-center text-center text-sm text-gray-300 hover:text-white transition-colors cursor-pointer leading-tight"
          >
            <span className="inline-flex items-center gap-2 whitespace-nowrap">
              Made with love{" "}
              <i className="ri-heart-fill text-base text-red-400"></i>
            </span>
            <span className="whitespace-nowrap">Code4ever.dev</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
